var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4C8 4.2645 7.94865 4.51701 7.85539 4.74811C7.7498 4.90774 7.65286 5.07367 7.56523 5.24514C7.1988 5.70516 6.63383 6 6 6C4.89543 6 4 5.10457 4 4C4 2.89543 4.89543 2 6 2C7.10457 2 8 2.89543 8 4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4C20 5.10457 19.1046 6 18 6C17.3662 6 16.8012 5.70516 16.4348 5.24514C16.3471 5.07367 16.2502 4.90774 16.1446 4.74811C16.0513 4.51701 16 4.2645 16 4C16 2.89543 16.8954 2 18 2C19.1046 2 20 2.89543 20 4Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9655 7C16.9883 7.1971 17 7.39734 17 7.6C17 8.98006 16.4567 10.2482 15.5663 11.1747C15.7228 11.2949 15.8884 11.4037 16.062 11.5H17.25C17.8288 11.5 18.3658 11.651 18.8299 11.9138C20.6408 11.5317 22 9.9246 22 8C22 7.44772 21.5523 7 21 7H16.9655Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 11.5H7.938C8.11156 11.4037 8.2772 11.2949 8.4337 11.1747C7.54327 10.2482 7 8.98006 7 7.6C7 7.39734 7.01171 7.1971 7.03452 7H3C2.44772 7 2 7.44772 2 8C2 9.9246 3.35924 11.5317 5.17014 11.9138C5.6342 11.651 6.17125 11.5 6.75 11.5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.2C13.933 11.2 15.5 9.58822 15.5 7.6C15.5 5.61177 13.933 4 12 4C10.067 4 8.5 5.61177 8.5 7.6C8.5 9.58822 10.067 11.2 12 11.2Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.8C5 13.8059 5.7835 13 6.75 13H17.25C18.2165 13 19 13.8059 19 14.8C19 18.7764 15.866 22 12 22C8.13401 22 5 18.7764 5 14.8ZM16.0303 15.5303C16.3232 15.2374 16.3232 14.7626 16.0303 14.4697C15.7374 14.1768 15.2626 14.1768 14.9697 14.4697L11.5 17.9393L10.0303 16.4697C9.73744 16.1768 9.26256 16.1768 8.96967 16.4697C8.67678 16.7626 8.67678 17.2374 8.96967 17.5303L10.9697 19.5303C11.2626 19.8232 11.7374 19.8232 12.0303 19.5303L16.0303 15.5303Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.af3cd0a36d25ea0445a3ba2912249d00.svg";
export { ForwardRef as ReactComponent };